// @flow

import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { get } from "lodash";
import { getClassName } from "ui-kit/utils/component";
import { Page } from "components";
import { setMarketingEmailConsentInSettings } from "ducks/user/actions";
import { FormattedMessage } from "react-intl";
import "./Settings.scss";

export const ccn = getClassName("Settings");

type StateProps = {
  authorized: boolean
};

class Settings extends Component {
  state ={
    checkBoxVal: false
  }
  checkBox = (e) => {
    this.props.setMarketingEmailConsentInSettings(e.target.checked)
    this.setState({ checkBoxVal: e.target.checked });
  }

  componentWillReceiveProps(next) {
    const { checkBoxVal } = this.state;
    const consent = get(next, "user.settings.consent", false);

    if (consent !== checkBoxVal) {
      this.setState({ checkBoxVal: consent });
    }
  }

  render() {
    return (
      <Page>
        <div className={ccn("container")}>
          <h1 className={ccn("title")}>
            <FormattedMessage id="hbc.settings.title" defaultMessage="Settings" />
          </h1>
          <div className={ccn("row")}>
          <div className="form-check checkbox-slider--b-flat">
            <label>
              <input type="checkbox" onChange={this.checkBox} checked={this.state.checkBoxVal} /><span><p><FormattedMessage id="hbc.settings" defaultMessage="Yes, please email me updates, tips, and offers related to this product" /></p></span>
            </label>
          </div>
          </div>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  user: state.user.info
});

export default withRouter(connect(mapStateToProps, { setMarketingEmailConsentInSettings })(Settings));



// WEBPACK FOOTER //
// ./src/containers/settings/Settings.js